export default __webpack_public_path__ + "static/artifakt-element-bold-7c57dac4197a4fb11e654b225fadcba2.svg";